import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppSelector } from "../../../../store/hooks";

import { Image } from "antd";
import { selectStickerPackEntities, selectStickerPackIds } from "../../../../store/sticker_maker/stickerPacksSlice";

import Card from "./_Card";

const _ListGrid = () => {
  const ids           = useAppSelector(selectStickerPackIds);
  const stickerPacks  = useAppSelector(selectStickerPackEntities);

  const renderSticker = (id: EntityId) => {
    const stickerPack = stickerPacks[id];

    if (!stickerPack) {
      return;
    }

    return <Card stickerPack={stickerPack} key={`sticker_pack-${id}`} />;
  }

  return (
    <>
      <Image.PreviewGroup>
        {ids && ids.map(renderSticker)}
      </Image.PreviewGroup>
    </>
  );
}

export default _ListGrid;
